import { motion } from 'framer-motion';
import Button from '../UI/Button';

export default function SocialProofScreen({ product, onContinue }) {

  const nextSteps = [
    {
      step: 1,
      title: "Physician Review",
      description: "You're already pre-qualified. After checkout, a board-certified physician will review your information and begin the approval process.",
      color: "renuvia-gold"
    },
    {
      step: 2,
      title: "Fast Prescription Approval",
      description: "Most prescriptions are approved in less than 24 hours. If needed, same-day consultations with a licensed clinician are available — at no extra charge.",
      color: "renuvia-gold"
    },
    {
      step: 3,
      title: "Medication Shipping",
      description: "Once approved, your medication is prepared and shipped. You'll receive tracking info within 2 business days, and your prescription will be on its way.",
      color: "renuvia-gold"
    },
    {
      step: 4,
      title: "Monthly Refills",
      description: "Your treatment automatically ships every 30 days. We'll send email and text reminders 3 days before each shipment with tracking info. Manage your subscription anytime through your patient portal (skip, pause, or cancel with one click).",
      color: "renuvia-gold"
    },
    {
      step: 5,
      title: "Unlimited Support",
      description: "Have questions about your progress, side effects, or dosage? You'll have unlimited, 24/7 access to our care team and licensed clinicians — whenever you need us.",
      color: "renuvia-gold",
      highlight: "unlimited, 24/7 access"
    }
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="max-w-3xl mx-auto"
    >
      <div className="bg-white rounded-luxury shadow-luxury p-8">
        {/* Title */}
        <h2 className="text-3xl md:text-4xl font-bold text-charcoal text-center mb-4">
          What Happens <span className="text-renuvia-gold">Next?</span>
        </h2>

        <p className="text-lg text-center text-slate mb-8">
          Here's your step-by-step journey to renewed vitality
        </p>

        {/* What Happens Next Section */}
        <div>


          <div className="space-y-6 mb-8">
            {nextSteps.map((step, index) => (
              <motion.div
                key={step.step}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.3 + index * 0.1 }}
                className="flex gap-4"
              >
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gradient-to-br from-renuvia-gold to-renuvia-gold/60 flex items-center justify-center">
                  <span className="font-bold text-white">{step.step}</span>
                </div>
                <div className="flex-1 border-l-2 border-gray-100 pl-4 pb-4">
                  <p className="font-bold text-charcoal mb-1">
                    <span className="text-renuvia-gold text-sm">STEP {step.step}</span>
                  </p>
                  <h4 className="font-bold text-charcoal text-lg mb-2">{step.title}</h4>
                  <p className="text-slate text-sm leading-relaxed">
                    {step.highlight ? (
                      <>
                        {step.description.split(step.highlight)[0]}
                        <span className="text-renuvia-gold font-semibold italic">{step.highlight}</span>
                        {step.description.split(step.highlight)[1]}
                      </>
                    ) : (
                      step.description
                    )}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        <Button onClick={onContinue} fullWidth>
          Continue to Your Personalized Plan →
        </Button>
      </div>
    </motion.div>
  );
}
